import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar } from '@fortawesome/pro-solid-svg-icons';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';

import { connect } from 'react-redux';
import { addStep } from './store/workflow/actions';

import { Button } from 'components/ui/button';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';

const VoucherApprovalWorkflowEmptyState = ({ addStep }) => {
  return (
    <Empty className="bg-white">
      <Empty.Media>
        <FontAwesomeIcon icon={faFileInvoiceDollar} />
      </Empty.Media>
      <Empty.Content>Get started by clicking on the "Add Workflow" button</Empty.Content>
      <Empty.Actions>
        <Button icon={faCirclePlus} label="Add Workflow" size="sm" variant="ghost" onClick={addStep} />
      </Empty.Actions>
    </Empty>
  );
};

VoucherApprovalWorkflowEmptyState.propTypes = {
  addStep: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  addStep,
};

export default connect(null, mapDispatchToProps)(VoucherApprovalWorkflowEmptyState);
